import { useEffect, useState } from 'react';

/**
 * Hook that cacthes clicks outside of the passed ref
 */
export default function useClickOutside(ref: any, except?: any) {
  const [clickedOutside, setClickedOutside] = useState(false);

  useEffect(() => {
    // catches click on target
    const handleClickOutside = (event: any) =>
      setClickedOutside(!ref.current?.contains(event.target) && !except?.current?.contains(event.target));

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);

    // Unbind the event listener on clean up
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [ref, except]);

  return { clickedOutside };
}
